import type { AvailableLanguagesType } from '#root/global.type';
import type { ResourceLanguage } from 'i18next';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';

export * from './lang.model';
export const locales: Record<AvailableLanguagesType, ResourceLanguage> = {
  en: {
    translation: en
  },
  fr: {
    translation: fr
  },
  es: {
    translation: es
  }
};

export type { AvailableLanguagesType };
